module.exports = __webpack_public_path__ + "41bd34496a5580e81617d393918c683e.pdf";